export default "__VITE_ASSET__cac72378__"